export default {
	purchase: 'Purchase',
	sell: 'Sell'
}